import { render, staticRenderFns } from "./memberCentre.vue?vue&type=template&id=3b362cd1&"
import script from "./memberCentre.vue?vue&type=script&lang=js&"
export * from "./memberCentre.vue?vue&type=script&lang=js&"
import style0 from "./memberCentre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports